export class Patrimonial {

    constructor(config = {}) {
        this.model = {
            id: {
                value: null,
                header: 'Código',
            },
            corriente: { 
                value: 0, 
                header: 'Corriente:', 
                required: 'Valor requerido.' 
            },
            fijo: { 
                value: 0, 
                header: 'Fijo:', 
                required: 'Valor requerido.' 
            },
            otro_activo: {
                value: 0,
                header: 'Otros activos:',
                required: 'Valor requerido.'
            },
            total_activo: { 
                value: 0, 
                header: 'Total activo:', 
                required: 'Valor requerido.' 
            },
            corto_plazo: { 
                value: 0, 
                export: false, 
                header: 'Corto plazo:', 
                required: 'Valor requerido.' 
            },
            largo_plazo: { 
                value: 0, 
                export: false, 
                header: 'Largo plazo:', 
                required: 'Valor requerido.' 
            },
            total_pasivos: { 
                value: 0, 
                export: false, 
                header: 'Total pasivos:', 
                required: 'Valor requerido.' 
            },
            patrimonio: {
                value: 0,
                export: false,
                header: 'Patrimonio:',
                required: 'Valor requerido.'
            },
            ingreso_estimado_mensual: { 
                value: 0, 
                export: false, 
                header: 'Ingreso Estimado Mensual US$:', 
                required: 'Valor requerido.' 
            },
            egreso_estimado_mensual: {
                value: 0,
                export: false,
                header: 'Egreso Estimado Mensual US$:',
                required: 'Valor requerido.'
            },
            origen_ingreso: {
                value: null,
                header: 'Origen de los Ingresos:',
                required: 'Seleccione alguna opción'
            },
            otro_ingreso_detalle: {
                value: '',
                header: 'Detalle de Origen de Ingresos:',
                maxLength: 'Máximo 250 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 250,
                min: 4,
            },
        }
    }
}
